import React, { FC } from "react";

export const Warning: FC = (props) => (
	<svg
		width="25"
		height="24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M24.085 20.776 12.834 1.36A.708.708 0 0 0 12.226 1a.693.693 0 0 0-.608.361L.328 20.825a.814.814 0 0 0-.02.779c.125.24.37.396.627.396h22.562c.396 0 .72-.347.72-.771a.756.756 0 0 0-.132-.453Z"
			fill="#E07800"
		/>
		<path
			d="m11.326 13.832-.254-3.822C11.022 9.266 11 8.73 11 8.405c0-.441.116-.789.347-1.035.232-.246.536-.369.912-.369.456 0 .767.16.92.478.151.318.23.774.23 1.367 0 .355-.02.71-.057 1.071l-.34 3.93c-.036.47-.116.825-.239 1.078a.626.626 0 0 1-.608.377c-.29 0-.485-.123-.6-.362-.11-.246-.189-.615-.24-1.107Zm.89 5.246c-.326 0-.608-.101-.847-.31-.239-.21-.362-.508-.362-.884 0-.333.116-.608.348-.84.231-.23.513-.347.846-.347.333 0 .623.116.861.348.24.231.355.514.355.84 0 .368-.123.665-.362.875a1.218 1.218 0 0 1-.84.318Z"
			fill="#fff"
		/>
	</svg>
);
